//import NotFoundData from "components/NotFoundData";
import styled from "@emotion/styled";
import { Button, Card, Col, Row, Typography } from "antd";

import { FC } from "react";
import TableCampaign from "./CampaignTable";
import { goBack, search } from "assets/icons";
import { useNavigate } from "react-router-dom";
import { PlusOutlined } from "@ant-design/icons";
import { useGetNewsList } from "hooks/useNews";
import { useAppSelector } from "store";

interface TableCampaignListProps {}

const TableCampaignList: FC<TableCampaignListProps> = () => {

  const factoryId = useAppSelector((state) => state.auth.profile?.user?.role?.ref_id);

    const navigate = useNavigate();
    const { data: dataNews, refetch: reload  } = useGetNewsList(
    {
        // id: "",
        // search: "",
        ref_id: factoryId,
        ref_type: "factory",
        is_bangbow: false,
        // category: "",
        // is_approve: true, 
        // page_number: true,
        // row_per_page: "your_row_per_page_value",
        // offset: your_offset_value,
        // limit: your_limit_value,
    }
    );

  return (
    <>
    <Row className="rowgap-vbox" gutter={[24, 0]}>
      <Col span={24}>
        <Card bordered={false}>
          <HeaderTabs>
            <IconWrapper
              onClick={() => {
                navigate("/setting");
              }}
            >
              <SpanIcon>{goBack}</SpanIcon>
            </IconWrapper>
            <Typography.Title level={5}>จัดการข่าวสารและโปรโมชั่น</Typography.Title>
            <RightIconWrapper></RightIconWrapper>
          </HeaderTabs>
          <>
            <TextWrapper>
                <Button type="primary" style={{ marginLeft: 'auto' }}
                    onClick={() => {
                        navigate("create-campaign");
                    }}>
                    <PlusOutlined /> เพิ่มข่าวสารและโปรโมชั่น
                </Button>
            </TextWrapper>
            <TableCampaign data={dataNews?.data} reload={reload}/>
          </>
        </Card>
      </Col>
    </Row>
  </>
  );
};

export default TableCampaignList;

const HeaderTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-direction: row;
  border-bottom: 1px solid #efefef;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 30px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const RightIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const TextWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 10px 10px 0px 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 10px;
`;
